import type { UrlAdapter } from '../../ports';

export const windowUrlAdapter: UrlAdapter = {
    getSearch: () => window.location.search,
    replaceSearch: (search: string) => {
        const url = new URL(window.location.href);
        url.search = search;
        window.history.replaceState(null, '', url.toString());
    },
};
